// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"socialButton-module--socialIcon--FcD2l"};